import "./App.css";
import Authors from "./components/Authors/Authors";
import ClipPaths from "./components/ClipPaths/ClipPaths";

function App() {
  return (
    <div className="App">
      <ClipPaths></ClipPaths>
      <Authors></Authors>
    </div>
  );
}

export default App;
